import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-headline-centered',
  templateUrl: './headline-centered.component.html'
})
export class HeadlineCenteredComponent implements OnInit {

  @Input() data;
  @Input() hideSubline;
  @Input() pullDownTop: boolean;

  constructor() {
  }

  ngOnInit() {
  }

}
